<div class="container my-3 p-3 General container-fluid">
  <h3>{{ "Careers.SearchTitle" | translate }}</h3>
  <p [innerHTML]="'Careers.TheLosAngeles'|translate"></p>

  <a href="https://forms.office.com/g/Dk2SvnFCRa" class="btn btn-primary" target="_blank">{{ "Careers.JobList" | translate }}</a>
  <br>
  <br>

  <h4>{{ "Careers.OnlineJobAppSystem" | translate }}</h4>
  <p [innerHTML]="'Careers.AppSystemDesc'|translate"></p>

  <a href="https://hr.lacounty.gov/how-to-apply/" class="btn btn-primary" target="_blank">{{ "Careers.OnlineJobAppSystem" | translate }}</a>
  <br>
  <br>
  <h4>{{ "Careers.AvailableOpportunities" | translate }}</h4>
  <p>{{ "Careers.Browse" | translate }}</p>
  <!-- <div class="row">
    <div class="col">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1764086015/Careers/GettyImages-909682030.jpg" style="max-width: 100%;" alt="buildings">
    </div>
    <div class="col">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1764086014/Careers/GettyImages-1359366815.jpg" style="max-width: 100%;" alt="Fountain">
    </div>

  </div> -->

</div>

